import {ChickEntity} from "../config/ChickConfig";

const {ccclass, property} = cc._decorator;

/**
 * 鸡图鉴 item
 */
@ccclass
export default class ItemChickenDrawing extends cc.Component {

    @property(sp.Skeleton)
    youngChickenSp : sp.Skeleton = null;
    @property(sp.Skeleton)
    chickenSp : sp.Skeleton = null;
    @property( sp.SkeletonData )
    chickenSkeletonData : sp.SkeletonData[] = [];
    @property(cc.Label)
    lbName : cc.Label = null;
    @property( cc.Label )
    lbDesc : cc.Label = null;
    @property(cc.Node)
    tickNode : cc.Node = null;

    private mChickenEntity : ChickEntity;

    onLoad () {}

    start () {

    }

    //绑定数据
    bindData( chickEntity : ChickEntity ){
        this.mChickenEntity = chickEntity;
        this.refreshData();
    }

    /**
     * 刷新数据
     */
    refreshData(){
        this.lbName.string = `${this.mChickenEntity.name}`;
        this.lbDesc.string = `简介:${this.mChickenEntity.desc}`;
        if ( this.mChickenEntity.becomeBigId ) {
            //小鸡
            this.youngChickenSp.node.active = true;
            this.scheduleOnce(()=>{
                this.youngChickenSp.setSkin( this.mChickenEntity.imgPath );
                this.youngChickenSp.setToSetupPose();
                this.youngChickenSp.setAnimation( 0 ,"Idle_01" , true );
            });
        }else{
            //成年鸡
            this.chickenSp.node.active = true;
            this.scheduleOnce(()=>{
                switch ( this.mChickenEntity.id ) {
                    case 2 : this.chickenSp.skeletonData = this.chickenSkeletonData[0];break;
                    case 4 : this.chickenSp.skeletonData = this.chickenSkeletonData[2];break;
                    case 6 : this.chickenSp.skeletonData = this.chickenSkeletonData[1];break;
                    case 8 : this.chickenSp.skeletonData = this.chickenSkeletonData[3];break;
                    case 9 : this.chickenSp.skeletonData = this.chickenSkeletonData[4];break;
                    case 10 :this.chickenSp.skeletonData = this.chickenSkeletonData[5];break;
                }
                if ( this.mChickenEntity.id == 9 || this.mChickenEntity.id == 10 ) {
                    this.chickenSp.setAnimation( 0 ,"Idle" , true );
                }else{
                    this.chickenSp.setAnimation( 0 ,"Idle_01" , true );
                }

            });
        }
    }

}
